//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"BodyOutputOption",1,0],[0,"CopyOriginal",1,0],[0,"DistanceTolerance",1,0],[0,"LimitMethod",1,0],[1,"LimitTools",0,"ScCollector",0],[1,"Offset",0,"Expression",0],[0,"SideEdgeShapeOption",1,0],[0,"SurfaceShapeOption",1,0],[1,"TargetBoundaryEdges",0,"ScCollector",0]],[[[],"ReverseExtensionSide",{},0,0]],[]];
SPLM.Features.ExtendSheetBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ExtendSheetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ExtendSheetBuilder.Limit = Object.freeze({
    "Offset" : "Offset", "UntilSelected" : "UntilSelected"});

SPLM.Features.ExtendSheetBuilder.SurfaceShape = Object.freeze({
    "NaturalCurvature" : "NaturalCurvature", "NaturalTangent" : "NaturalTangent", "Mirrored" : "Mirrored"});

SPLM.Features.ExtendSheetBuilder.SideEdgeShape = Object.freeze({
    "Automatic" : "Automatic", "Tangent" : "Tangent", "Orthogonal" : "Orthogonal"});

SPLM.Features.ExtendSheetBuilder.BodyOutput = Object.freeze({
    "ExtendOriginalSheet" : "ExtendOriginalSheet", "ExtendasNewFace" : "ExtendasNewFace", "ExtendasNewSheet" : "ExtendasNewSheet"});

export default SPLM;